import cpdTypes from "./action-types";
import axios from "axios";
import { showSuccess, showError } from "../../app/toastify";
import commonTypes from "../common/action-types";
import download from "downloadjs";

const types = { ...commonTypes, ...cpdTypes };

export const getProgramCategories = () => {
  return async (dispatch) => {
    try {
      const { data } = await axios.get("/api/cpd/program-categories");

      dispatch({
        type: types.SET_PROGRAM_CATEGORIES,
        data,
      });
    } catch (error) {
      showError(error);
    }
  };
};

export const getPrograms = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.get("/api/cpd/programs");

      dispatch({ type: types.END_LOADING });

      dispatch({
        type: types.SET_PROGRAMS,
        data: data,
      });
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const saveProgram = (payload, cb) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.post("/api/cpd/programs", payload);

      dispatch({ type: types.END_LOADING });

      dispatch({
        type: types.ADD_OR_UPDATE_PROGRAM,
        data,
      });

      cb();
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const getOrganizationTypes = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.get("/api/cpd/organization-types");

      dispatch({ type: types.END_LOADING });

      dispatch({
        type: types.SET_ORGANIZATION_TYPES,
        data: data,
      });
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const saveOrganizationType = (payload, cb) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.post("/api/cpd/organization-types", payload);

      dispatch({ type: types.END_LOADING });

      dispatch({
        type: types.ADD_OR_UPDATE_ORGANIZATION_TYPE,
        data,
      });

      cb();
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const getTrainingProviders = (query, setTotalRecords, setLoader) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      setLoader(true);

      const { data } = await axios.get(
        "/api/cpd/training-providers" +
          "?" +
          new URLSearchParams(query).toString(),
      );
      setLoader(false);

      dispatch({ type: types.END_LOADING });

      dispatch({
        type: types.SET_TRAINING_PROVIDERS,
        data: data.records || [],
      });

      setTotalRecords(data.totalRecords || 0);
    } catch (error) {
      setLoader(false);
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const saveTrainingProvider = (payload, cb) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.post("/api/cpd/training-providers", payload);

      dispatch({ type: types.END_LOADING });

      dispatch({
        type: types.ADD_OR_UPDATE_TRAINING_PROVIDER,
        data: data,
      });

      cb();
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const getTraingProviderAttachmentTypes = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.get("/api/cpd/attachment-types");

      dispatch({ type: types.END_LOADING });

      dispatch({
        type: types.SET_TRAINING_PROVIDER_ATTACHMENT_TYPES,
        data,
      });
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const saveTraingProviderAttachmentTypes = (payload, cb) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.post("/api/cpd/attachment-types", payload);

      dispatch({ type: types.END_LOADING });

      dispatch({
        type: types.ADD_OR_UPDATE_TRAINING_PROVIDER_ATTACHMENT_TYPE,
        data,
      });

      cb();
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const getSubPrograms = (programId) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      dispatch({
        type: types.SET_SUB_PROGRAMS,
        data: [],
      });

      const { data } = await axios.get("/api/cpd/sub-programs/" + programId);

      dispatch({ type: types.END_LOADING });

      dispatch({
        type: types.SET_SUB_PROGRAMS,
        data: data,
      });
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const saveSubProgram = (payload, cb) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.post("/api/cpd/sub-programs", payload);

      dispatch({ type: types.END_LOADING });

      dispatch({
        type: types.ADD_OR_UPDATE_SUB_PROGRAM,
        data,
      });

      cb();
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const getTopics = (subProgramId) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      dispatch({
        type: types.SET_TOPICS,
        data: [],
      });

      const { data } = await axios.get("/api/cpd/topics/" + subProgramId);

      dispatch({ type: types.END_LOADING });

      dispatch({
        type: types.SET_TOPICS,
        data: data,
      });
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const saveTopic = (payload, cb) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.post("/api/cpd/topics", payload);

      dispatch({ type: types.END_LOADING });

      dispatch({
        type: types.ADD_OR_UPDATE_TOPIC,
        data,
      });

      cb();
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const getVenues = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      dispatch({
        type: types.SET_VENUES,
        data: [],
      });

      const { data } = await axios.get("/api/cpd/venues");

      dispatch({ type: types.END_LOADING });

      dispatch({
        type: types.SET_VENUES,
        data: data,
      });
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const saveVenue = (payload, cb) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.post("/api/cpd/venues", payload);

      dispatch({ type: types.END_LOADING });

      dispatch({
        type: types.ADD_OR_UPDATE_VENUE,
        data,
      });

      cb();
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const getTrainings = (query, setTotalRecords, setLoader) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      setLoader(true);

      const { data } = await axios.get(
        "/api/cpd/trainings" + "?" + new URLSearchParams(query).toString(),
      );

      setLoader(false);

      dispatch({ type: types.END_LOADING });

      dispatch({
        type: types.SET_TRAININGS,
        data: data.records || [],
      });

      setTotalRecords(data.totalRecords || 0);
    } catch (error) {
      setLoader(false);
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const saveTraining = (payload, cb, onError) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.post("/api/cpd/trainings", payload);

      dispatch({ type: types.END_LOADING });

      dispatch({
        type: types.ADD_OR_UPDATE_TRAINING,
        data,
      });

      cb();
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
      if (typeof onError === "function") onError(error);
    }
  };
};

export const approveTraining = (payload, cb) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.post("/api/cpd/training-approvals", payload);

      dispatch({ type: types.END_LOADING });

      dispatch({
        type: types.ADD_OR_UPDATE_TRAINING,
        data,
      });

      cb();
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const cancelTraining = (payload, cb) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.post("/api/cpd/cancel-training", payload);

      dispatch({ type: types.END_LOADING });

      if (!data?.id)
        dispatch({
          type: types.REMOVE_TRAINING,
          id: payload.id,
        });
      else
        dispatch({
          type: types.ADD_OR_UPDATE_TRAINING,
          data,
        });

      cb();
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const getProviderPrograms = (providerId) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      dispatch({
        type: types.SET_TOPICS,
        data: [],
      });

      const { data } = await axios.get(
        "/api/cpd/provider-programs/" + providerId,
      );

      dispatch({ type: types.END_LOADING });

      dispatch({
        type: types.SET_PROVIDER_PROGRAMS,
        data,
      });
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const getTraineeCategories = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.get("/api/cpd/trainee-categories");

      dispatch({ type: types.END_LOADING });

      dispatch({
        type: types.SET_TRAINEE_CATEGORIES,
        data: data,
      });
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const saveTraineeCategory = (payload, cb) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.post("/api/cpd/trainee-categories", payload);

      dispatch({ type: types.END_LOADING });

      dispatch({
        type: types.ADD_OR_UPDATE_TRAINEE_CATEGORY,
        data,
      });

      cb();
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const getTraineeSubCategories = (traineeCategoryId = "", cb = null) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      dispatch({
        type: types.SET_TRAINEE_SUB_CATEGORIES,
        data: [],
      });

      const { data } = await axios.get(
        "/api/cpd/trainee-sub-categories/" + traineeCategoryId,
      );

      dispatch({ type: types.END_LOADING });

      dispatch({
        type: types.SET_TRAINEE_SUB_CATEGORIES,
        data: data,
      });

      !!cb && cb(data);
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const saveTraineeSubCategory = (payload, cb) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.post(
        "/api/cpd/trainee-sub-categories",
        payload,
      );

      dispatch({ type: types.END_LOADING });

      dispatch({
        type: types.ADD_OR_UPDATE_TRAINEE_SUB_CATEGORY,
        data,
      });

      cb();
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const getTrainerCategories = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.get("/api/cpd/trainer-categories");

      dispatch({ type: types.END_LOADING });

      dispatch({
        type: types.SET_TRAINER_CATEGORIES,
        data: data,
      });
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const saveTrainerCategory = (payload, cb) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.post("/api/cpd/trainer-categories", payload);

      dispatch({ type: types.END_LOADING });

      dispatch({
        type: types.ADD_OR_UPDATE_TRAINER_CATEGORY,
        data,
      });

      cb();
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const getTrainers = (query, setTotalRecords, setLoader) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      setLoader(true);

      const { data } = await axios.get(
        "/api/cpd/trainers" + "?" + new URLSearchParams(query).toString(),
      );

      setLoader(false);

      dispatch({ type: types.END_LOADING });

      dispatch({
        type: types.SET_TRAINERS,
        data: data.records || [],
      });

      setTotalRecords(data.totalRecords || 0);
    } catch (error) {
      setLoader(false);
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const saveTrainer = (payload, incrementTotalRecods, cb) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_WAIT });
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.post("/api/cpd/trainers", payload);

      incrementTotalRecods();

      cb();

      dispatch({ type: types.END_LOADING });
      dispatch({ type: types.END_WAIT });

      dispatch({
        type: types.ADD_OR_UPDATE_TRAINER,
        data,
      });
      showSuccess("Saved successfully");
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      dispatch({ type: types.END_WAIT });
      showError(error);
    }
  };
};

export const downloadTrainerImportTemplate = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });
      const { data } = await axios.get("/api/cpd/trainers/import-template", {
        responseType: "blob",
      });
      dispatch({ type: types.END_LOADING });
      download(
        data,
        "cpd-trainers-import-template.xlsx",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      );
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const importTrainersFromExcel = (file, onDone) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_WAIT });
      dispatch({ type: types.START_LOADING });
      const formData = new FormData();
      formData.append("file", file);
      const { data } = await axios.post("/api/cpd/trainers/import", formData);
      dispatch({ type: types.END_LOADING });
      dispatch({ type: types.END_WAIT });
      if (typeof onDone === "function") onDone(null, data);
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      dispatch({ type: types.END_WAIT });
      if (typeof onDone === "function") onDone(error, null);
      else showError(error);
    }
  };
};

export const saveCohortVenueTrainees = (payload, cb) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_WAIT });
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.post(
        "/api/cpd/cohort-venue-trainees",
        payload,
      );

      cb();

      dispatch({ type: types.END_LOADING });
      dispatch({ type: types.END_WAIT });

      // dispatch({
      //   type: types.ADD_OR_UPDATE_TRAINER,
      //   data,
      // });

      showSuccess("Saved successfully");
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      dispatch({ type: types.END_WAIT });
      showError(error);
    }
  };
};

export const getMembershipRequests = (query, setTotalRecords, setLoader) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      setLoader(true);

      const { data } = await axios.get(
        "/api/cpd/membership-requests" +
          "?" +
          new URLSearchParams(query).toString(),
      );
      setLoader(false);

      dispatch({ type: types.END_LOADING });

      dispatch({
        type: types.SET_MEMBERSHIP_REQUESTS,
        data: data.records || [],
      });
      setTotalRecords(data.totalRecords || 0);
    } catch (error) {
      setLoader(false);

      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const approveMembershipRequest = (payload, cb) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.put("/api/cpd/membership-requests", payload);

      dispatch({ type: types.END_LOADING });

      dispatch({
        type: types.ADD_OR_UPDATE_MEMBERSHIP_REQUEST,
        data: data,
      });

      cb();
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const getCountries = () => {
  return async (dispatch) => {
    try {
      const { data } = await axios.get("/api/cpd/countries");
      dispatch({
        type: types.SET_COUNTRIES,
        data,
      });
    } catch (error) {
      showError(error);
    }
  };
};

export const getVenueTypes = () => {
  return async (dispatch) => {
    try {
      const { data } = await axios.get("/api/cpd/venue-types");
      dispatch({
        type: types.SET_VENUE_TYPES,
        data,
      });
    } catch (error) {
      showError(error);
    }
  };
};
